export default __webpack_public_path__ + "static/media/devices.e02d7209.svg";